var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTerminal01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1216",
    d: "M7.2,12.2c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8h21.7c3.2,0,5.8-2.6,5.8-5.8s-2.6-5.8-5.8-5.8H7.2  M7.2,11.3h21.7c3.7,0,6.7,3,6.7,6.7s-3,6.7-6.7,6.7H7.2c-3.7,0-6.7-3-6.7-6.7S3.5,11.3,7.2,11.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTerminal01);
export default __webpack_public_path__ + "static/media/ico-terminal-01.2afcee06ef464c329af186e2b2c8a76b.svg";
export { ForwardRef as ReactComponent };